import { createSelector } from 'reselect';

export const getUsersIsLoading = state => state.users.isLoading;
export const getUsersPagination = state => state.users.pagination;

export const getUserById = (state, userId) => state.entities.users[userId];

export const moreUsersToGet = state =>
  state.users.pagination
    ? state.users.pagination.current_page < state.users.pagination.total_pages
    : true;

const getIds = state => state.users.data;
const getResult = state => state.entities.users;
const getSort = state => state.users.sort;
const getSearch = state => state.users.search;
export const getAllUsers = createSelector(
  getIds,
  getResult,
  getSort,
  getSearch,
  (ids, result, sort, search) => {
    return ids
      .map(id => {
        return result[id];
      })
      .filter(entity => {
        if (search.field === null) {
          return entity;
        } else {
          let value = search.value.toUpperCase();
          if (entity[search.field].toUpperCase().includes(value)) {
            return entity;
          }
          return null;
        }
      })
      .sort((a, b) => {
        let fieldA = a[sort.field];
        let fieldB = b[sort.field];
        if (typeof fieldA === 'string') {
          fieldA = a[sort.field].toUpperCase();
          fieldB = b[sort.field].toUpperCase();
        }

        if (fieldA < fieldB) {
          return sort.reverse ? 1 : -1;
        }
        if (fieldA > fieldB) {
          return sort.reverse ? -1 : 1;
        }

        return 0;
      });
  }
);



// WEBPACK FOOTER //
// ./src/redux/selectors/users.js